import React from 'react';
import bespokeRoiCalculatorHtml from './bespokeRoiCalculatorHtml';

const BespokeRoiCalculator: React.FC = () => {
  return (
    <iframe
      srcDoc={bespokeRoiCalculatorHtml}
      title="Bespoke ROI Calculator"
      style={{ width: '100%', height: '100vh', border: 'none' }}
    />
  );
};

export default BespokeRoiCalculator;
